import {ApiCacheEntry} from './types/ApiCacheEntry'

export default {
    setApiCache: (state, cache: ApiCacheEntry) => {
        state.api_cache[cache.key] = cache.value
    }
}
